import { Filmstrip } from '../../abstract/filmstrip.class';
import { FilmstripType } from '../../abstract/filmstrip.type';
import { Background } from '../../object';
import { Font } from '../../object/font/font.class';
import { Text } from '../../object/text/text.class';
import { $ } from '../../signal';
import { CountMarioModule } from '../count-mario.class';

export class CountMarioSection2Answer extends Filmstrip<CountMarioModule> {
  public name = '公佈答案';

  public override readonly type = FilmstripType.COUNT_MARIO_SECTION_2_ANSWER;

  public override readonly withMobileInteractive = true;

  public override hit = $.computed(() => {
    const options = this.module?.data?.options();
    if (!options) return null;

    const answers = options.filter((option) => option.isAnswer());
    if (answers.length > 1) {
      return '當有多個答案時，玩家必須全部選對才算答對';
    }

    return null;
  });

  public projection = {
    background: new Background({
      type: 'IMAGE',
      src: 'assets/count-mario/answer.jpg',
    }),
    publishTheAnswer: new Font({ align: 'center' }),
    answer: new Font({ align: 'center' }),
    numberOfWinner: new Font(),
  };

  public mobile = {
    background: new Background({ hex: '#D0D9E4' }),
    correctText: new Text({ content: '答對了', align: 'center' }),
    wrongText1: new Text({ content: '答錯了～正確答案是', align: 'center' }),
    wrongText2: new Text({ content: '請等待下一個環節', align: 'center' }),
    wrongFont: new Font({ align: 'center' }),
  };

  public data = {};

  public override nextButtonName = '下一頁（發送數隻）';

  public mobileToolbar = {
    options: ['答對', '答錯'],
    selectedOptionIndex: 0,
  };

  public override _processError = $.computed(() => ({
    'projection.background': this.projection.background.error(),
    'projection.publishTheAnswer': this.projection.publishTheAnswer.error(),
    'projection.answer': this.projection.answer.error(),
    'projection.numberOfWinner': this.projection.numberOfWinner.error(),
    'mobile.background': this.mobile.background.error(),
    'mobile.correctText': this.mobile.correctText.error(),
    'mobile.wrongText1': this.mobile.wrongText1.error(),
    'mobile.wrongText2': this.mobile.wrongText2.error(),
    'mobile.wrongFont': this.mobile.wrongFont.error(),
  }));
}
